import _merge from 'lodash/merge';
import { keyCodes } from '@pelo-plugins/keys';

const getAdvancedConfig = () => {
  const config = {};
  config.appSettings = {
    stage: { memoryPressure: 521600 },
  };

  return config;
};

export const getKeyCodes = () => keyCodes;

export const getSettings = () => {
  const advancedConfig = getAdvancedConfig();

  return _merge(
    {
      appSettings: {
        stage: {
          forceTxCanvasSource: true,
        },
      },
      platformSettings: {
        router: {
          updateHash: false,
        },
      },
    },
    advancedConfig,
  );
};
